import { Controller } from 'stimulus'
import { getLogger } from '@blueberry/observability'

const logger = getLogger('balance/analytics')

declare global {
  interface Window {
    // facebook pixel
    fbq: (
      command: 'track' | 'init' | 'trackCustom',
      event: string,
      data?: unknown,
      options?: { eventID: string },
    ) => void
  }
}

export default class extends Controller {
  static values = {
    event: String,
  }

  declare eventValue: string
  declare hasEventValue: boolean

  connect() {
    if (!this.hasEventValue) {
      logger.error('Missing event value')
      return
    }

    this.trackFacebook(this.eventValue)
  }

  private trackFacebook(event: string) {
    try {
      window.fbq('trackCustom', event)
    } catch (error) {
      logger.error('Error tracking Facebook event:', error)
    }
  }
}
